import React, { useEffect, useState, useMemo } from 'react';
import useAsync from '../hooks/useAsync';
import { useNavigate } from 'react-router-dom';
import UserServices from '../services/UserServices';
import ViewUser from './View Model/ViewUser';
import Modal from 'react-modal';
import ReactPaginate from 'react-paginate';
import { FaRegEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'

Modal.setAppElement('#root');

function TodayUser() {
  const { data: apiResponse, error, isLoading, run } = useAsync(UserServices.getTodayUser);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage] = useState(10);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  
  // Extract customers array from API response
  const usersArray = useMemo(() => {
    if (!apiResponse || !apiResponse.data || !apiResponse.data.customers) return [];
    return apiResponse.data.customers;
  }, [apiResponse]);
  
  // Pagination logic
  const indexOfLastUser = (currentPage + 1) * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = usersArray.slice(indexOfFirstUser, indexOfLastUser);
  const pageCount = Math.ceil(usersArray.length / usersPerPage);
  
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };
  
  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  
  // Handle view details
  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setIsViewModalOpen(true);
  };
  
  // Handle close modal
  const handleCloseModal = () => {
    setIsViewModalOpen(false);
    setSelectedUser(null);
  };
  
  // Fetch data on component mount
  useEffect(() => {
    run();
  }, [run]);
  
  // Handle loading and error states
  if (isLoading) {
    return <div className="text-center p-4">Loading...</div>;
  }
  
  if (error) {
    return <div className="text-center p-4 text-danger">Error: {error.message}</div>;
  }
  
  // Check if there's no data
  if (!usersArray || usersArray.length === 0) {
    return (
      <div className="right_col" role="main">
        <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
          <div className="my-auto">
            <h5 className="page-title fs-21 mb-1">Today User <span className="badge bg-warning" /></h5>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Today User List
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="text-center p-5">
          <p>No users found for today.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">Today User <span className="badge bg-warning">{usersArray.length}</span></h5>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Today User List
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container-box px-0 user-manager">
        <div className="container-box-inner table-reponsive-tabe">
          <table id="example" className="table table-striped" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>USER TYPE</th>
                <th>IMAGE</th>
                <th>NAME</th>
                <th>MOBILE NO.</th>
                <th>ADDRESS</th>
                <th>REGISTRATION DATE</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map((user, index) => (
                <tr key={user._id || index}>
                  <td>{index + 1 + indexOfFirstUser}</td>
                  <td><span className="usertype">{user.deviceType || "N/A"}</span></td>
                  <td>
                    <img 
                      src={user.image ? `${process.env.REACT_APP_URL}${user.image}` : 'img/profile-img.png'} 
                      alt="" 
                      style={{ height: '50px', width: '50px', objectFit: 'contain' }} 
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'img/profile-img.png';
                      }}
                    />
                  </td>
                  <td style={{ maxWidth: '100px', wordWrap: 'break-word' }}>
                    {`${user.firstName || "N/A"} ${user.lastName || ""}`.trim() || "N/A"}
                  </td>
                  <td>{user.mobileNo || "N/A"}</td>
                  <td>{user.address || "N/A"}</td>
                  <td>{user.createdAt ? formatDate(user.createdAt) : "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {/* Pagination */}
          {pageCount > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                activeClassName={'active'}
                forcePage={currentPage}
              />
            </div>
          )}
          
          {/* Summary Info */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              Showing {Math.min(indexOfFirstUser + 1, usersArray.length)} to {Math.min(indexOfLastUser, usersArray.length)} of {usersArray.length} entries
            </div>
          </div>
        </div>
      </div>

      {/* View User Modal */}
      {selectedUser && (
        <Modal
          isOpen={isViewModalOpen}
          onRequestClose={handleCloseModal}
          className="modal-dialog modal-lg"
          overlayClassName="modal-backdrop"
        >
          <ViewUser user={selectedUser} onClose={handleCloseModal} />
        </Modal>
      )}
    </div>
  );
}

export default TodayUser;